/* ns-motion-founder — NordBench Pro founder story page.
   Gives the page's sections the shared [data-ns-motion] primitives (their
   Liquid is used by other templates, so it is left untouched), splits the two
   hero headlines into words that rise a line at a time, and counts the two
   headline numbers up. Every hidden state lives in ns-motion-founder.css
   behind html.ns-motion-ok, so this file can never leave content invisible.
   A selector may carry "@n" to seed the shared --ns-motion-i stagger index. */
(function () {
  var NS = window.NSMotion;
  if (!NS || NS.reduced) return;

  var BELIEF = '[id$="__fa_founder_hero_belief"] ';
  var HERO = '[id$="__fa_founder_hero_Yh3GXa"] ';

  var MAP = {
    'fade-up':
      '.fa-spr__trust, .fa-spr__swiper-outer@1, .ns-mwc__intro@1, .ns-mwc__closing,' +
      '.ns-mwc__closing-bold@1, .ns-mei__footer, .ccv5__eyebrow, .ccv5__savings-card,' +
      '.nbr__cta-wrap@2, .tvu2__carousel@1, .ns-faqwi__intro, .ugc__subheading@2,' +
      '.ugc__carousel, .ugc__reviews@1, .ufo2__subheading@2, .ufo2__card, .ufo2__rating@1,' +
      BELIEF + '.fa-fh__button@2',
    fade: '.ccv5__footnote',
    'ns-clip':
      '.media-with-text__media, .ns-fsb__single-image__fig, .ccv5__savings-image-wrap@1,' +
      '.nbr__image, .ns-faqwi__media@1, .ufo2__media',
    'ns-pill': '.ns-mwc__media',
    'ns-card': '.ns-mei__card',
    'ns-settle': BELIEF + '.fa-fh__mobile-img img, ' + BELIEF + '.fa-fh__bg img',
    'ns-line': '.ccv5__savings-rule',
    'ns-pop': '.fa-spr__trust-image img@1, .ufo2__badge',
    'ns-glow': '.ccv5__row--featured',
    stagger:
      '.content-fa, .ns-fsb__richtext, .ns-fsb__xitems, .ns-mwc__points, .obe__header,' +
      '.obe__grid, .ns-mei__header, .ccv5__tbody, .nbr__copy, .nbr__features,' +
      '.tvu2__header, .ns-usp-grid__header, .ns-usp-grid__items, .ns-faqwi__items,' +
      '.ns-gtb__head, .ns-gtb__rail, .ufo2__rows, ' + BELIEF + '.fa-fh__richtext'
  };

  /* Statement headings read in a line at a time, like the hero. */
  var HEADLINES =
    '.title-fa, .ns-fsb__hheading, .ns-mwc__heading, .ccv5__heading, .ugc__heading, .ufo2__heading';

  function q(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function apply(root) {
    Object.keys(MAP).forEach(function (motion) {
      MAP[motion].split(',').forEach(function (raw) {
        var parts = raw.trim().split('@');
        if (!parts[0]) return;
        q(parts[0], root).forEach(function (el) {
          if (el.hasAttribute('data-ns-motion') || el.hasAttribute('data-ns-motion-stagger')) return;
          if (motion === 'stagger') el.setAttribute('data-ns-motion-stagger', '');
          else el.setAttribute('data-ns-motion', motion);
          if (parts[1]) el.style.setProperty('--ns-motion-i', parts[1]);
        });
      });
    });
    // The five review stars land one after another.
    q('.ugc__stars svg', root).forEach(function (el, i) {
      el.setAttribute('data-ns-motion', 'ns-pop');
      el.style.setProperty('--ns-motion-i', i);
    });
  }

  /* Anything already on screen must never render hidden, so it is marked as
     revealed in the same task it is marked as animatable — no flash. */
  function settleInView(root) {
    q('[data-ns-motion], [data-ns-motion-stagger]', root).forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > -1) {
        el.classList.add('is-inview');
        el.__nsMotion = true;
      }
    });
  }

  /* Wrap every word in a span, then give words sharing a top edge the same
     stagger index so the headline reads in one line at a time. */
  function splitWords(el) {
    if (!el || el.querySelector('.ns-f-w')) return false;
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var nodes = [];
    var n;
    while ((n = walker.nextNode())) if (n.nodeValue.trim()) nodes.push(n);
    if (!nodes.length) return false;
    nodes.forEach(function (node) {
      var frag = document.createDocumentFragment();
      node.nodeValue.split(/(\s+)/).forEach(function (part) {
        if (!part) return;
        if (/^\s+$/.test(part)) return frag.appendChild(document.createTextNode(part));
        var s = document.createElement('span');
        s.className = 'ns-f-w';
        s.textContent = part;
        frag.appendChild(s);
      });
      node.parentNode.replaceChild(frag, node);
    });
    var line = -1;
    var last = null;
    q('.ns-f-w', el).forEach(function (w) {
      var top = Math.round(w.getBoundingClientRect().top);
      if (last === null || Math.abs(top - last) > 4) {
        line++;
        last = top;
      }
      w.style.setProperty('--ns-motion-i', line);
    });
    return true;
  }

  /* Count a headline number up, holding its finished width so the line around
     it cannot reflow, and restoring the exact original string at the end. */
  function countUp(el) {
    var raw = el.textContent;
    var m = raw.match(/\d[\d.,]*/);
    if (!m) return;
    var num = m[0].replace(/[.,]+$/, '');
    var target = parseFloat(num.replace(/,/g, ''));
    if (!isFinite(target) || target <= 0) return;
    var dp = num.indexOf('.') > -1 ? num.split('.')[1].length : 0;
    var grouped = num.indexOf(',') > -1;
    var pre = raw.slice(0, m.index);
    var post = raw.slice(m.index + num.length);
    var w = el.getBoundingClientRect().width;
    if (w) el.style.minWidth = Math.ceil(w) + 'px';
    var t0 = 0;
    function frame(now) {
      if (!t0) t0 = now;
      var p = Math.min(1, (now - t0) / 1500);
      var s = (target * (1 - Math.pow(1 - p, 4))).toFixed(dp);
      if (grouped) s = s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      el.textContent = pre + s + post;
      if (p < 1) requestAnimationFrame(frame);
      else el.textContent = raw;
    }
    requestAnimationFrame(frame);
  }

  function watchCounters(root) {
    var targets = q('.ccv5__savings-amount', root);
    q('.fa-spr__trust-text', root).forEach(function (p) {
      if (p.querySelector('.ns-f-num')) return;
      var html = p.innerHTML;
      var m = html.match(/\d[\d,]*/);
      if (!m) return;
      p.innerHTML =
        html.slice(0, m.index) + '<span class="ns-f-num">' + m[0] + '</span>' + html.slice(m.index + m[0].length);
      targets.push(p.querySelector('.ns-f-num'));
    });
    if (!targets.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          io.unobserve(e.target);
          countUp(e.target);
        });
      },
      { threshold: 0.6 }
    );
    targets.forEach(function (t) {
      io.observe(t);
    });
  }

  function init(root) {
    q(HEADLINES, root).forEach(function (el) {
      if (splitWords(el)) el.setAttribute('data-ns-motion', 'ns-words');
    });
    apply(root);
    settleInView(root);
    NS.observe(root || document);
    watchCounters(root);
  }

  /* The opening headline is above the fold. Its CSS wipe holds it at the
     hidden keyframe for 450ms, so splitting it into words is only safe while
     that hold is still running — the animation's own currentTime says so
     exactly. Past the hold, the CSS wipe is left to finish on its own. */
  var h1 = document.querySelector(HERO + '.fa-fh__heading h1');
  var held = h1 && h1.getAnimations && h1.getAnimations()[0];
  if (held && held.currentTime < 380 && splitWords(h1)) h1.classList.add('ns-f-split');

  var belief = document.querySelector(BELIEF + '.fa-fh__heading h2');
  if (belief && splitWords(belief)) belief.setAttribute('data-ns-motion', 'ns-words');

  /* Fast scrolling while images are still loading can carry an element past
     the viewport between two observer frames. This sweep — one frame at most,
     removed once everything has arrived — guarantees nothing is left behind. */
  var ticking = false;
  function rescue() {
    var waiting = 0;
    q('[data-ns-motion], [data-ns-motion-stagger]').forEach(function (el) {
      if (el.classList.contains('is-inview')) return;
      if (el.getBoundingClientRect().bottom < window.innerHeight * 0.9) NS.reveal(el);
      else waiting++;
    });
    if (!waiting) window.removeEventListener('scroll', onScroll);
  }
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      rescue();
    });
  }

  init(document);
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('load', rescue);
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
